<template>
  <div>
    <div class="vx-row">
      <vx-card>
        <div class="vx-row float-right my-3">
          <div class="vx-col w-full">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              class="mr-3"
              size="small"
              @click="add('Country')"
              >{{ $t("setup.label.AddCountry") }}</vs-button
            >
          </div>
        </div>
        <div class="vx-row float-right my-3">
          <div class="vx-col w-full">
            <vs-button
              v-if="true"
              icon-pack="feather"
              icon="icon-list"
              class="mr-3"
              size="small"
              @click="$router.push('/setup/address-master')"
              >{{ $t("setup.label.listview") }}</vs-button
            >
          </div>
        </div>
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/address-master" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.AddressMasterTreeView") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- <vs-divider /> -->
        <vs-table
          v-if="false"
          :max-items="descriptionItems[0]"
          pagination
          :data="addresss"
          :description="!treeview"
          :search="!treeview"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-git-branch"
                @click="treeview = !treeview"
                size="small"
                >{{ $t("setup.label.TreeView") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="add('Country')"
                size="small"
                >{{ $t("setup.label.AddCountry") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead" v-if="!treeview">
            <vs-th>{{ $t("table.countryName") }}</vs-th>
            <vs-th>{{ $t("table.stateName") }}</vs-th
            ><vs-th>{{ $t("table.districtName") }}</vs-th>
            <vs-th>{{ $t("table.cityName") }}</vs-th>
          </template>

          <template slot-scope="{ data }" v-if="!treeview">
            <vs-tr
              :key="index"
              :data="address"
              v-for="(address, index) in data"
            >
              <vs-td :data="address.countryName">{{
                address.countryName
              }}</vs-td>
              <vs-td :data="address.stateName">{{ address.stateName }}</vs-td>
              <vs-td :data="address.districtName">{{
                address.districtName
              }}</vs-td>
              <vs-td :data="address.cityName">{{ address.cityName }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div v-if="true">
          <tree-item
            :node="treedata"
            @add-in="addIn"
            @edit-item="editItem"
            @delete-item="deleteItem"
            @service-available="serviceAvailable"
            class="tree-container"
          ></tree-item>
        </div>
      </vx-card>
    </div>

    <delete-popup
      :deletePopup="deletePopup"
      :title="title"
      @deletePressed="removeItem()"
      @cancelPressed="deletePopup = false"
    />

    <!-- //Addd -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        class="popup-close mid-popup"
        :title="$t('Add ') + title"
        :active.sync="addPopup"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-col mb-4 sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="title + $t('setup.label.Code')"
                :key="resetKey"
              >
                <vs-input
                  style="margin-top: 10px"
                  :label="title + $t('setup.label.Code')"
                  type="text"
                  v-model="addObj.entityCode"
                  :placeholder="$t('setup.label.EnterCode')"
                  class="w-full mb-2 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col mb-4 sm:w-full w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="title + $t('setup.label.Name')"
                :key="resetKey"
              >
                <vs-input
                  :label="title + $t('setup.label.Name')"
                  type="text"
                  v-model="addObj.entityName"
                  :placeholder="$t('setup.label.EnterName')"
                  class="w-full mb-2 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="center mt-10">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="addEntity"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("setup.label.Confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>

    <!-- //Edit -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('setup.label.Edit') + title"
        :active.sync="editPopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                <vs-input
                  :label="title + $t('setup.label.Code')"
                  type="text"
                  v-model="addObj.entityCode"
                  class="w-full mb-3 font-semibold starlabel"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <vs-input
                :label="title + $t('setup.label.Name')"
                type="text"
                v-model="addObj.entityName"
                class="w-full font-semibold starlabel"
              />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editPopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="editEntity">{{
                $t("setup.label.Confirm")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <!--///Services-->
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('setup.label.Service_Availablity_for_the') + title"
        :active.sync="servicePopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full" style="height: 15rem">
                <small class="date-label font-semibold">{{
                  $t("setup.label.SelectServices")
                }}</small>
                <multiselect
                  v-model="selectedServices"
                  :options="availableServices"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :hide-selected="true"
                  :option-height="10"
                  class="min-w-200 w-full mb-2"
                  open-direction="bottom"
                  :placeholder="$t('setup.label.Select_One_or_More')"
                  :show-labels="false"
                  label="serviceCode"
                  track-by="serviceCode"
                  :preselect-first="false"
                >
                  <span
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    :some="search"
                    >{{ values.length }} {{$t("setup.label.options_selected")}}</span
                  >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="servicePopup = false">{{
                $t("setup.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="saveServices">{{
                $t("setup.label.Save")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import TreeItem from "./TreeBrowser.vue";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
const addEmptyObj = {
  entityName: "",
  entityCode: "",
};
export default {
  data() {
    return {
      resetKey: 0,
      addObj: addEmptyObj,
      selectedServices: [],

      searchOption: 0,
      addressTreeObj: [],
      descriptionItems: [5, 10, 15],
      deletePopup: false,
      addPopup: false,
      editPopup: false,
      servicePopup: false,
      treeview: false,
      delId: 0,
      addresss: [],
      service: { id: "" },
      servicePost: { addressId: "", addressType: "", services: [] },
      searchword: "",
      initSelected: ["node-1"],
      treedata: { name: "Countries", id: 0, change: 0, children: [] },
      id: "",
      title: "",
      parentId: 0,
    };
  },

  computed: {
    ...mapState({
      addressData: (state) => state.addressMaster.addressData,
      availableServices: (state) => state.addressMaster.availableServices,
      addressService: (state) => state.addressMaster.addressService,
    }),
  },
  components: {
    "tree-item": TreeItem,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    async getaddressList() {
      try {
        await this.$store.dispatch("addressMaster/fetchAddressData");
        this.addresss = this.addressData;
      } catch (e) {
        console.log("something went to wrong while addresss:", e);
      }
    },
    async getServices() {
      try {
        await this.$store.dispatch("addressMaster/serviceAvailableAction");
      } catch (e) {
        console.log("something went to wrong while addresss:", e);
      }
    },
    async addEntity() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        if (this.title === "Country") {
          await this.$store.dispatch(
            "addressMaster/saveCountryAction",
            this.addObj
          );
        }
        if (this.title === "State") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveStateAction",
            this.addObj
          );
        }
        if (this.title === "District") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveDistrictAction",
            this.addObj
          );
        }
        if (this.title === "City") {
          this.addObj.parentEntityId = this.parentId;
          await this.$store.dispatch(
            "addressMaster/saveCityAction",
            this.addObj
          );
        }
        this.addPopup = false;
        this.treedata.change += 1;
        await this.getaddressList();
        this.convertTree(this.addresss);
        this.resetForm();
        this.$router.push(`/setup/address-master`);
        if (this.resp.data.resourceId && this.resp.data.resourceId) {
          //
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.message.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },
    async removeItem() {
      try {
        if (this.title === "Country") {
          await this.$store.dispatch(
            "addressMaster/deleteCountryAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "State") {
          await this.$store.dispatch(
            "addressMaster/deleteStateAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "District") {
          await this.$store.dispatch(
            "addressMaster/deleteDistrictAction",
            this.id
          );
          this.getaddressList();
        }
        if (this.title === "City") {
          await this.$store.dispatch("addressMaster/deleteCityAction", this.id);
          this.getaddressList();
        }
        this.treedata.change += 1;
        this.deletePopup = false;
        await this.getaddressList();
        this.resetForm();
        this.$router.push(`/setup/address-master`);
      } catch {}
    },
    async editEntity() {
      try {
        if (this.title === "Country") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editCountryAction", {
            id: this.id,
            data: this.addObj,
          });
          this.editPopup = false;
          this.resetForm();
          this.redirect();
          if (this.editPopup == false) {
          }
        }
        if (this.title === "State") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editStateAction", {
            id: this.id,
            data: this.addObj,
          });
          this.editPopup = false;
          this.resetForm();
          this.redirect();
        }
        if (this.title === "District") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editDistrictAction", {
            id: this.id,
            data: this.addObj,
          });
          this.editPopup = false;
          this.resetForm();
          this.redirect();
        }
        if (this.title === "City") {
          delete this.addObj.parentEntityId;
          await this.$store.dispatch("addressMaster/editCityAction", {
            id: this.id,
            data: this.addObj,
          });
          this.editPopup = false;
          this.resetForm();
          this.redirect();
        }

        this.treedata.change += 1;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while edit Address:", e);
      }
    },
    async saveServices() {
      this.servicePost.addressId = this.id;
      this.servicePost.addressType = this.title;
      this.servicePost.services = [];
      for (let temp of this.selectedServices) {
        this.servicePost.services.push(temp.id);
      }
      try {
        await this.$store.dispatch("addressMaster/saveServiceAction", {
          id: this.id,
          data: this.servicePost,
        });

        this.servicePopup = false;
        this.resetForm();
        this.redirect();
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while edit Address:", e);
      }
    },

    redirect() {
      const that = this;
      setTimeout(function () {
        that.$router.push("/setup/address-master").catch(() => {});
      }, 150);
    },
    editData(id) {
      this.$router.push(`/editaddress/${id}`);
    },
    resetForm() {
      this.addObj = addEmptyObj;
      this.addObj.entityCode = "";
      this.addObj.entityName = "";
    },
    async removeaddress(id) {
      try {
        await deleteaddress(id);
        this.getaddressList();
        this.deletePopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    addDistricts(val) {
      //
    },
    addIn(id, type, code) {
      if (type === "country") {
        this.title = "State";
        this.parentId = id;
        this.addPopup = true;
      } else if (type === "state") {
        this.title = "District";
        this.parentId = id;
        this.addPopup = true;
      } else if (type === "district") {
        this.title = "City";
        this.parentId = id;
        this.addPopup = true;
      }
      this.resetKey++;
      (this.addObj.entityCode = ""), (this.addObj.entityName = "");
    },
    editItem(id, type, code, name) {
      if (type === "country") {
        this.title = "Country";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;

        this.editPopup = true;
      } else if (type === "state") {
        this.title = "State";
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.id = id;
        this.editPopup = true;
      } else if (type === "district") {
        this.title = "District";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.editPopup = true;
      } else if (type === "city") {
        this.title = "City";
        this.id = id;
        this.addObj.entityCode = code;
        this.addObj.entityName = name;
        this.editPopup = true;
      }
    },
    deleteItem(id, type, code) {
      if (type === "country") {
        this.title = "Country";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "state") {
        this.title = "State";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "district") {
        this.title = "District";
        this.id = id;
        this.deletePopup = true;
      }
      if (type === "city") {
        this.title = "City";
        this.id = id;
        this.deletePopup = true;
      }
    },
    async getSelectedServices(id, type) {
      try {
        await this.$store.dispatch("addressMaster/fetchAddressServices", {
          id,
          type,
        });
        let tempServices = this.addressService;

        this.selectedServices = [];
        for (let temp of tempServices) {
          for (let temp2 of this.availableServices) {
            if (temp2.id === temp.serviceId) this.selectedServices.push(temp2);
          }
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while edit Address:", e);
      }
    },
    serviceAvailable(id, type, code) {
      this.getSelectedServices(id, type);
      this.id = id;
      this.servicePopup = true;
      this.title = type;
    },
    add(title) {
      this.title = title;
      this.addPopup = true;
      this.resetKey++;
    },
    convertTree(val) {
      let i = -1;
      let tempi = -1;
      for (let countryTempObj of val) {
        //For Country

        let uniCountry = true;

        for (let childrenObj of this.treedata.children) {
          uniCountry = true;
          if (countryTempObj.countryName == childrenObj.name) {
            uniCountry = false;
            i = this.treedata.children.indexOf(childrenObj.name);
            break;
          }
        }
        if (uniCountry) {
          if (tempi <= i) {
            tempi = i;
          }
          i = tempi + 1;
          i = this.treedata.children.length;
          this.treedata.children.push({
            name: countryTempObj.countryName,
            id: countryTempObj.countryId,
            code: countryTempObj.countryCode,
            type: "country",
            children: [],
          });

          //For State

          let j = -1;
          let tempj = -1;
          for (let stateTempObj of val) {
            if (this.treedata.children[i] != undefined) {
              if (stateTempObj.stateName != undefined) {
                let uniState = true;
                if (this.treedata.children[i] != undefined) {
                  for (let stateObj of this.treedata.children[i].children) {
                    uniState = true;
                    if (stateTempObj.stateName == stateObj.name) {
                      uniState = false;
                      j = this.treedata.children[i].children.indexOf(
                        stateObj.name
                      );
                      break;
                    }
                  }
                }
                if (uniState) {
                  j = this.treedata.children[i].children.length;
                  if (stateTempObj.countryName == countryTempObj.countryName)
                    this.treedata.children[i].children.push({
                      name: stateTempObj.stateName,
                      id: stateTempObj.stateId,
                      type: "state",
                      code: stateTempObj.stateCode,
                      children: [],
                    });

                  //For District

                  let districtDatas = [];

                  let k = -1;
                  let tempk = -1;
                  for (let districtTempObj of val) {
                    if (districtTempObj.districtName != undefined) {
                      let uniDist = true;
                      if (this.treedata.children[i].children[j] != undefined) {
                        for (let distObj of this.treedata.children[i].children[
                          j
                        ].children) {
                          uniDist = true;
                          if (districtTempObj.districtName == distObj.name) {
                            uniDist = false;
                            k = this.treedata.children[i].children[
                              j
                            ].children.indexOf(distObj.name);
                            break;
                          }
                        }
                      }

                      if (uniDist) {
                        if (
                          this.treedata.children[i].children[j] != undefined
                        ) {
                          if (
                            districtTempObj.stateName == stateTempObj.stateName
                          ) {
                            k =
                              this.treedata.children[i].children[j].children
                                .length;
                            this.treedata.children[i].children[j].children.push(
                              {
                                name: districtTempObj.districtName,
                                id: districtTempObj.districtId,
                                code: districtTempObj.districtCode,
                                type: "district",
                                children: [],
                              }
                            );
                          }

                          districtDatas.push({
                            name: districtTempObj.districtName,
                            id: districtTempObj.districtId,
                            code: districtTempObj.districtCode,
                            type: "district",
                            children: [],
                          });

                          if (
                            this.treedata.children[i].children[j] != undefined
                          ) {
                            for (let tempDistric of this.treedata.children[i]
                              .children[j].children) {
                              for (let tempCity of val) {
                                if (tempCity.cityName != undefined) {
                                  if (
                                    tempCity.districtName == tempDistric.name
                                  ) {
                                    let uniCity = true;
                                    if (
                                      this.treedata.children[i].children[j]
                                        .children[k] != undefined
                                    ) {
                                      for (let somecity of this.treedata
                                        .children[i].children[j].children[k]
                                        .children) {
                                        if (
                                          somecity.name == tempCity.cityName
                                        ) {
                                          uniCity = false;
                                          break;
                                        } else {
                                          uniCity = true;
                                        }
                                      }

                                      if (uniCity) {
                                        if (
                                          districtTempObj.districtName ==
                                          tempCity.districtName
                                        )
                                          this.treedata.children[i].children[
                                            j
                                          ].children[k].children.push({
                                            name: tempCity.cityName,
                                            type: "city",
                                            code: tempCity.cityCode,
                                            id: tempCity.cityId,
                                          });
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
  },
  watch: {
    addresss(val) {
      this.convertTree(val);
      this.addDistricts(val);
    },
  },
  created() {
    this.getaddressList();
    this.getServices();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.tree-block {
  float: left;
  width: 33%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px dotted #ccccdd;
  overflow: auto;
  height: 800px;
}
.treebtn1 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 1px 3px;
  border-radius: 5px;
  margin-right: 5px;
  color: rgb(148, 147, 147);
}
.treebtn2 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(97, 97, 97);
}
.treebtn3 {
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-radius: 5px;
  margin-left: 5px;
  color: rgb(63, 63, 63);
}
.tree-search-input {
  width: 70%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  border: 1px solid #ccc;
}
.tree-search-btn {
  width: 25%;
  padding: 6px 8px;
  outline: none;
  border-radius: 6px;
  background-color: rgb(218, 218, 218);
  border: 1px solid rgb(226, 225, 225);
  color: rgb(117, 117, 117);
}
</style>
<style lang="scss">
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(var(--vs-primary), 0.3);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}

.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;

  margin-right: 0.625rem;

  line-height: 1;

  margin-bottom: 0.5rem;
}
.tree-container {
  max-width: 26rem;
}
</style>
